import { MdReport as ReportIcon } from 'react-icons/md';
import { Theme, Typography } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { makeStyles } from 'tss-react/mui';
import { FC } from 'react';

const OnBoardingDiscovery: FC<
  React.PropsWithChildren<OnBoardingDiscoveryProps>
> = ({ value, info, total }) => {
  const { classes } = useStyles();
  const computedValue = total ? ((value || 0) * 100) / total : 0;

  return (
    <div className={classes.discoveryBody}>
      <Typography variant='h6' color='text.primary'>
        Gathering info on your repos...
      </Typography>

      {total > 0 && (
        <div className={classes.repoCount}>
          <Typography variant='body2' color='textPrimary'>
            {value} out of {total} applications were discovered
          </Typography>
        </div>
      )}

      <Typography variant='body2' color='textPrimary'>
        {info}
      </Typography>

      <div className={classes.progress}>
        <LinearProgress
          value={computedValue}
          variant={!value || value === total ? 'indeterminate' : 'determinate'}
        />
      </div>
      <div className={classes.footer}>
        <ReportIcon className={classes.icon} />
        <Typography fontSize='small' component='span'>
          We’ll take you to your OX dashboard when discovery is done
        </Typography>
      </div>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  discoveryBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  repoCount: {
    marginBlockStart: theme.spacing(1),
    whiteSpace: 'pre-line',
    textAlign: 'center',
  },
  footer: {
    lineHeight: 1,
    marginBlockStart: theme.spacing(5),
    '& > *': {
      verticalAlign: 'middle',
    },
  },
  icon: {
    marginInlineEnd: theme.spacing(0.5),
  },
  progress: {
    marginBlockStart: theme.spacing(1),
    width: '100%',
  },
  textContainer: {
    maxWidth: '80%',
    marginInline: 'auto',
    wordBreak: 'break-word',
  },
}));

interface OnBoardingDiscoveryProps {
  info?: string;
  value: number;
  total: number;
}

export default OnBoardingDiscovery;
